var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../api/axios";
import { useEffect, useState } from "react";
export const APPLICATION_NAME = "React";
export const getEnvironmentDetails = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [error, setError] = useState();
    useEffect(() => {
        let isMounted = true;
        const fetchSettings = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const res = yield axiosPrivate.get("/React/GetAppSettings");
                if (!res.data.success) {
                    if (isMounted) {
                        setError("Something unexpected happened while loading the page. Code: LC1");
                    }
                    return;
                }
                if (isMounted) {
                    setData(res.data);
                    setError(undefined);
                }
            }
            catch (e) {
                console.error(e);
                if (isMounted) {
                    setData(undefined);
                    setError("Something unexpected happened while loading the page. Code: LC2");
                }
            }
            finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        });
        fetchSettings();
        return () => {
            isMounted = false;
        };
    }, []);
    return { loading, data, error };
};
